import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import StoreStore from '../../../../store';
export function useUnreadCount() {
  var _useState = useState(function () {
      return StoreStore.getUnreadCount();
    }),
    _useState2 = _slicedToArray(_useState, 2),
    unreadCount = _useState2[0],
    setUnreadCount = _useState2[1];
  useEffect(function () {
    function updateUnreadCount() {
      setUnreadCount(StoreStore.getUnreadCount());
    }
    StoreStore.addChangeMessagesListener(updateUnreadCount);
    return function () {
      StoreStore.removeChangeMessagesListener(updateUnreadCount);
    };
  }, []);
  return unreadCount;
}